import { PropertyCtaStatechartService } from 'common/module/property-cta/statechart/service';
import { PropertyLeadEmailStore } from 'common/module/property-lead-email/store';
import { PropertyContactedStoreService } from 'common/service/property-contacted-store/service';
import { StatsService } from 'common/service/stats/service';
import { StatsTealiumProviderService } from 'common/service/stats-tealium-provider/service';
import { LeadEmailFormPropertyFactory } from 'desktop/module/lead/email/form/property.factory';

const service = new PropertyLeadEmailStore(
  LeadEmailFormPropertyFactory(),
  StatsService(),
  PropertyContactedStoreService(),
  PropertyCtaStatechartService(),
  StatsTealiumProviderService()
);

service.initialize();

export const PropertyLeadEmailService = () => service;
